import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ account, preferences }) =>
    present(
      repository
        .editUserPreferences(account, preferences)
        .then(() => ({ account, preferences }))
        .catch(() => Promise.reject({ account, preferences })),
    );
}

export type { Interactor };

export { createInteractor };
